import React from 'react';

const ServiceDetail = ({ service }) => {
    return (
        <div className="col-md-4 col-sm-6 col-12 text-center">
            <img src={service.img} alt="" />
            <h4 className='py-4'
            >{service.name}</h4>
            <p
                style={{
                    color: "#9B9B9B",
                }}
            >{service.desc}</p>
        </div>
    );
};

export default ServiceDetail;